var React = require('react');

function IconCheckYellow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFD600","fillRule":"nonzero"},[React.createElement("path",{"d":"M1.186 6.193a1.198 1.198 0 01.008-1.741 1.317 1.317 0 011.81.008l2.668 2.588a1.198 1.198 0 01-.008 1.741 1.317 1.317 0 01-1.811-.008L1.186 6.193z","key":0}),React.createElement("path",{"d":"M10.196 1.173c.5-.48 1.311-.48 1.81.001.5.482.5 1.261-.001 1.742L5.863 8.81c-.5.48-1.311.48-1.811-.002-.5-.481-.499-1.26.002-1.741l6.142-5.894z","key":1})]));
}

IconCheckYellow.defaultProps = {"width":"13","height":"10"};

module.exports = IconCheckYellow;

IconCheckYellow.default = IconCheckYellow;
